// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-form[data-v-7516bb04] {\n  margin-top: 20px;\n}\n.margin-top-10[data-v-7516bb04] {\n  margin-top: 10px;\n}\n.dialog-footer[data-v-7516bb04] {\n  position: absolute;\n  bottom: 0;\n  right: 20px;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  z-index: 999;\n  background-color: white;\n}\n", ""]);
// Exports
module.exports = exports;
